import { updateObject } from "../utility";
import {
    GETAGAINSATICKET,
    GETAGAINTICKET
} from "Stores/actionTypes";

const INIT_STATE = {
    getAllSATicketAgain: false,
    getAllTicketAgain: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GETAGAINSATICKET:
      return updateObject(state, {
        getAllSATicketAgain: action.data,
      });
    case GETAGAINTICKET : 
      return updateObject(state, {
        getAllTicketAgain: action.data,
      });
    default:
      return state;
  }
};
